import { Button, Divider } from 'antd';
import styled from 'styled-components';

export const PromptWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ChatPanel = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 3px;
  box-shadow: rgb(100 100 111 / 20%) 0 7px 29px 0;
  border-radius: 10px;
`;

export const Label = styled.span`
  flex-shrink: 0;
  font-weight: bold;
  margin-right: 8px;
  white-space: nowrap;
`;

export const Value = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
`;

export const StyledDivider = styled(Divider)`
  margin: 8px auto;
  width: 95%;
  min-width: 95%;
`;

export const ChatFloatBtn = styled(Button)`
  position: absolute;
  right: 20px;
  bottom: 20px;
  z-index: 99;
`;

export const DashLinkDivider = styled.div`
  margin: 0 5px;
  border-right: 1px solid rgb(204 204 204);
  min-width: 5px;
`;

export const DisclaimerFooter = styled.div`
  text-align: center;
  font-size: 12px;
  font-style: italic;
  color: #888;
`;

export const ChatAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 10%;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  flex: 1;
`;

export const MessageText = styled.p`
  color: #666;
  font-size: 16px;
  line-height: 1.5;
  max-width: 500px;
  text-align: center;
`;
